import { unauthorizedAPI } from "@/config/axios.config";
import { delegationSession } from "@/lib/delegation-session";
import { UtilsService } from "../utils";
import type { DelegationView, DelegationSaveResponse } from "@/types";

const utils = new UtilsService();

/**
 * The recipient side of a delegation. Every call carries the emailed token
 * rather than a session, so it uses `unauthorizedAPI`: the authorized client
 * force-redirects to login on 401, which would throw an external person out of
 * a form they have every right to be filling in.
 */
class DelegationService {
  // GET /form-delegations/shared/{token}
  async view(token: string): Promise<DelegationView> {
    return utils.handleApiRequest(() =>
      unauthorizedAPI.get(`/form-delegations/shared/${token}`)
    );
  }

  // POST /form-delegations/shared/save
  async save(responses: unknown): Promise<DelegationSaveResponse> {
    return utils.handleApiRequest(() =>
      unauthorizedAPI.post(
        "/form-delegations/shared/save",
        { responses },
        { headers: delegationSession.headers() }
      )
    );
  }

  // POST /form-delegations/shared/submit
  async submit(responses: unknown): Promise<DelegationSaveResponse> {
    return utils.handleApiRequest(() =>
      unauthorizedAPI.post(
        "/form-delegations/shared/submit",
        { responses },
        { headers: delegationSession.headers() }
      )
    );
  }

  // POST /form-delegations/shared/upload
  async uploadFile(file: File) {
    const formData = new FormData();
    formData.append("file", file);

    return utils.handleApiRequest(() =>
      unauthorizedAPI.post("/form-delegations/shared/upload", formData, {
        headers: {
          ...delegationSession.headers(),
          "Content-Type": "multipart/form-data",
        },
      })
    );
  }

  // GET /form-delegations/shared/database/{id}
  async getDatabase(id: string) {
    return utils.handleApiRequest(() =>
      unauthorizedAPI.get(`/form-delegations/shared/database/${id}`, {
        headers: delegationSession.headers(),
      })
    );
  }
}

export const delegationService = new DelegationService();
